import { useEffect, useState } from "react";

import { agoraDoInquilino } from "../relogio";

/**
 * O relógio da tela, batendo a cada `intervaloMs` — e só enquanto `ligado`. É o da
 * organização (ADR-059): na demonstração com o relógio avançado, o tempo dela.
 *
 * Existe para o prazo de 24 h ser visto **andando** (O-03, versão enxuta): um "vence em 3m"
 * parado não assusta ninguém; "2:59, 2:58…" é a evasão acontecendo na frente de quem
 * assiste. Desligado, não agenda nada: a tela sem prazo curto não re-renderiza por segundo.
 */
export function useAgora(intervaloMs = 1000, ligado = true): Date {
  const [agora, definirAgora] = useState(() => agoraDoInquilino());
  useEffect(() => {
    if (!ligado) return;
    definirAgora(agoraDoInquilino());
    const id = window.setInterval(
      () => definirAgora(agoraDoInquilino()),
      intervaloMs,
    );
    return () => window.clearInterval(id);
  }, [intervaloMs, ligado]);
  return agora;
}
